module.exports = __webpack_public_path__ + "static/media/white-logo.ef89cb81.png";